export const attachGoTopBtn = (): void => {
  const $buttons = document.querySelectorAll('[data-js-go-top-btn]')
  $buttons.forEach(el => {
    el.addEventListener('click', () => {
      window.scrollTo(0, 0)
    })
  })
}
